import config from "../../config"
import RequestService from "../RequestService"

const fetchTicketByUuid = (uuid, successCallback, failureCallback) => {
  RequestService.get(`${config.backendUrl}/ticket_workflow_steps/${uuid}/public_show`, successCallback, failureCallback)
}

export default fetchTicketByUuid;